export default {
  'searchQuestionnaire.list.button.newQuestionnaire': 'Novo Questionário',
  'searchQuestionnaire.list.description': 'Título',
  'searchQuestionnaire.list.numberOfQuestions': 'Número de Questões',
  'searchQuestionnaire.list.action': 'Ação',

  'searchQuestionnaire.remove': 'Remover Questionário',
  'searchQuestionnaire.remove.alert':
    'Você realmente deseja remover o questionário:',
  'searchQuestionnaire.remove.notification.success': 'Sucesso',
  'searchQuestionnaire.remove.notification.successDescription':
    'Questionário removido',

  'searchQuestionnaire.questions.list.button.newQuestion': 'Nova Questão',
  'searchQuestionnaire.questions.list.sequence': 'Sequência',
  'searchQuestionnaire.questions.list.description': 'Descrição',
  'searchQuestionnaire.questions.list.type': 'Tipo',
  'searchQuestionnaire.questions.list.type.MULTIPLE_CHOICE_SINGLE_ANSWER':
    'Única escolha',
  'searchQuestionnaire.questions.list.type.MULTIPLE_CHOICE_MULTIPLE_ANSWERS':
    'Multipla escolha',
  'searchQuestionnaire.questions.list.type.STARS_CLASSIFICATION':
    'Classificação',
  'searchQuestionnaire.questions.list.type.COMMENTS_BOX': 'Comentário',

  'searchQuestionnaire.replayDate.filter.startDate': 'Data de início',
  'searchQuestionnaire.replayDate.filter.endDate': 'Data de término',
  'searchQuestionnaire.replayDate.filter.button': 'Filtrar',

  'searchQuestionnaire.replayDate.list.customer': 'Cliente',
  'searchQuestionnaire.replayDate.list.responseDate': 'Data da resposta',
  'searchQuestionnaire.replayDate.list.action': 'Ação',
  'searchQuestionnaire.replayDate.list.see': 'Ver',

  'searchQuestionnaire.replayDate.modal.title': 'Questionário do cliente',
  'searchQuestionnaire.replayDate.modal.customer': 'Cliente',
  'searchQuestionnaire.replayDate.modal.sendDate': 'Data de envio',

  'searchQuestionnaire.emptyDescription': 'Não há dados para exibição',

  'searchQuestionnaire.syntheticAnalysis.comments.list.customer': 'Cliente',
  'searchQuestionnaire.syntheticAnalysis.comments.list.answer': 'Resposta',
};
